import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-contact-information',
  templateUrl: './contact-information.component.html',
  styleUrl: './contact-information.component.scss',
  standalone: false
})
export class ContactInformationComponent implements OnInit{

  constructor() { }

  ngOnInit(): void {
  }
  
}
